import { Link } from 'react-router-dom';
import _ from 'underscore';
import MeterDisplay from "./MeterDisplay";
import helpers from '../../lib/helpers';

function StanzaMetadataTable(props) {
	let authors = props.data && props.data.author ? _.where(props.data.author, {translator: false}) : [];
	let translators = props.data && props.data.author ? _.where(props.data.author, {translator: true}) : [];

	return <table className="table metadata-table">
		{
			props.data && <tbody>
				{
					props.data.collections && props.data.collections.length > 0 &&
					<tr><td><label>Safn</label></td><td>{helpers.metadataList(props.data.collections, helpers.routerUrls['erindi']+'?samsafn=', 'id', 'name')}</td></tr>
				}
				{
					props.data.type && props.data.type.length > 0 &&
					<tr><td><label>Tegund</label></td><td>{helpers.metadataList(props.data.type, helpers.routerUrls['erindi']+'?tegund=', 'id', 'name')}</td></tr>
				}
				{
					props.data.poem && props.data.poem.id &&
					<tr><td><label>Kvæði</label></td><td><Link to={helpers.routerUrls['kvaedi']+props.data.poem.id}>{props.data.poem.name}</Link></td></tr>
				}
				{
					props.data.dating &&
					<tr><td><label>Tímasetning</label></td><td>{props.data.dating}</td></tr>
				}
				{
					(props.data.year_from || props.data.year_to) &&
					<tr><td><label>Viðmiðunarártal</label></td><td>{props.data.year_from}{props.data.year_from && props.data.year_to != props.data.year_from ? '-'+props.data.year_from : ''}</td></tr>
				}
				{
					props.data.number &&
					<tr><td><label>Númer</label></td><td>{props.data.number}</td></tr>
				}
				{
					props.data.meter &&
					<tr>
						<td>
							<label>Bragarháttur</label>
						</td>
						<td>
							{helpers.metadataList([props.data.meter], helpers.routerUrls['bragarhaettir'], 'id', 'name')}
							{/* 
							<div className="mt-3">
								<MeterDisplay kennistrengur={props.data.meter.kennistrengur} innrim={props.data.meter.innrim} />
							</div>
							*/}
						</td>
					</tr>
				}
				{
					props.data.meter && props.data.meter.kennistrengur && <>
						<tr>
							<td colSpan={2}>
								<MeterDisplay kennistrengur={props.data.meter.kennistrengur} innrim={props.data.meter.innrim} />
							</td>
						</tr>
					</>
				}
				{
					authors && authors.length > 0 &&
					<tr><td><label>{authors.length > 1 ? 'Höfundar' : 'Höfundur'}</label></td><td>{helpers.metadataList(authors, helpers.routerUrls['einstaklingar'], 'id', (item) => item.name+(item.uncertain ? ' (ætlað)' : ''))}</td></tr>
				}
				{
					translators && translators.length > 0 &&
					<tr><td><label>{translators.length > 1 ? 'Þýðendur' : 'Þýðandi'}</label></td><td>{helpers.metadataList(translators, helpers.routerUrls['einstaklingar'], 'id', (item) => item.name+(item.uncertain ? ' (ætlað)' : ''))}</td></tr>
				}
			</tbody>
		}
	</table>
}

export default StanzaMetadataTable;